<form [formGroup]="addSellerDetails" (ngSubmit)="sellerDetailEdit()">
  <div class="modal-header">
    <h5 *ngIf="isEdit" class="modal-title tittle3" id="exampleModalLabel">Edit Details</h5>
    <h5 *ngIf="!isEdit" class="modal-title tittle3" id="exampleModalLabel">Add Details</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12 col-md-5 col-lg-4">
        <div class="md-form mt-0">
          <input mdbInput mdbValidate type="text" id="sellerName" formControlName="sellerName" class="form-control" />
          <label for="sellerName">Name</label>
          <mdb-error *ngIf="sellerName.invalid && (sellerName.dirty || sellerName.touched)">
            Required
          </mdb-error>
        </div>
      </div>
      <div class="col-sm-12 col-md-7 col-lg-4">
        <div class="md-form mt-0">
          <input mdbInput mdbValidate type="text" id="sellerCompanyDescription" formControlName="sellerCompanyDescription" class="form-control" />
          <label for="sellerCompanyDescription">Company Description</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4 col-lg-4">
        <div class="md-form mt-0">
          <input mdbInput mdbValidate type="text" id="sellerDba" formControlName="sellerDba" class="form-control" />
          <label for="sellerDba">Seller DBA</label>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4">
        <div class="md-form mt-0">
          <input mdbInput mdbValidate type="text" id="sellerFeid" formControlName="sellerFeid" class="form-control" />
          <label for="sellerFeid">Seller FEID</label>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-lg-4">
        <div class="md-form mt-0">
          <input mdbInput mdbValidate type="text" id="sellerDnB" formControlName="sellerDnB" class="form-control" />
          <label for="sellerDnB">Seller DNB</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-secondary1" mdbWavesEffect>Save changes</button>
    <button type="button" class="btn btn-secondary btn-outline-primary tc-1 blueborder" data-dismiss="modal" (click)="modalRef.hide()" mdbWavesEffect>Close</button>
  </div>
</form>
